import React, { useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Navbar = () => {
  const { user, logout, company, firms, selectedFirmId, setSelectedFirmId } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => (location.pathname === path ? 'active fw-bold text-white' : '');

  const selectedFirm = firms.find((f) => String(f.Id) === String(selectedFirmId));

  return (
    <header className="sticky-top shadow-sm" style={{ zIndex: 1040 }}>
      {/* MAIN APP HEADER */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark py-2 border-bottom border-secondary border-opacity-25" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #0369a1 100%)' }}>
        <div className="container-fluid px-2 px-md-4">
          {/* BRAND LOGO WITH COMPANY NAME & FIRM DETAILS DROPDOWN BELOW IT */}
          <div className="d-flex align-items-center gap-2 me-3">
            <div className="bg-warning text-dark rounded-circle p-2 d-flex align-items-center justify-content-center shadow-sm flex-shrink-0" style={{ width: 40, height: 40 }}>
              <i className="bi bi-building fs-5"></i>
            </div>
            <div className="d-flex flex-column">
              <Link to="/dashboard" className="text-decoration-none" title={`${company?.Address || company?.Comapny_Address || ''} | Tel: ${company?.Contact_no || company?.Company_Mobile || ''}`}>
                <span className="d-block lh-1 text-white fw-extrabold fs-6 text-uppercase" style={{ fontFamily: 'var(--app-font-heading)', letterSpacing: '0.02em' }}>
                  {company?.Company_Name || company?.Comapny_Name || 'Hari Ganga Fish Syndicate'}
                </span>
                {(company?.Contact_no || company?.Company_Mobile) && (
                  <span className="text-info opacity-75" style={{ fontSize: '0.68rem' }}>
                    <i className="bi bi-telephone-fill me-1"></i>{company?.Contact_no || company?.Company_Mobile}
                  </span>
                )}
              </Link>

              {/* FIRM DETAILS DROPDOWN DIRECTLY BELOW COMPANY NAME */}
              <div className="mt-1 d-flex align-items-center">
                <i className="bi bi-shop text-white me-1" style={{ fontSize: '0.75rem' }}></i>
                <select
                  className="form-select form-select-sm py-0 ps-2 pe-4 fw-bold text-dark bg-warning border-0 rounded-pill shadow-sm"
                  style={{ fontSize: '0.75rem', cursor: 'pointer', height: '24px', minHeight: '24px', width: 'auto', display: 'inline-block' }}
                  value={selectedFirmId}
                  onChange={(e) => setSelectedFirmId(Number(e.target.value))}
                  disabled={!!(user && user.firmId > 0)}
                >
                  {(!user || user.firmId === 0) && (
                    <option value={0} className="text-dark bg-white">सर्व फर्म्स / All Firms (Admin)</option>
                  )}
                  {firms.map((f) => (
                    <option key={f.Id} value={f.Id} className="text-dark bg-white">
                      {f.firmName} {f.ContactNo ? `(${f.ContactNo})` : ''}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* MOBILE NAV TOGGLER */}
          <button
            className="navbar-toggler border-0 shadow-none d-lg-none"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarContent"
          >
            <i className="bi bi-list fs-2 text-white"></i>
          </button>

          {/* NAVIGATION ITEMS & PROFILE */}
          <div className="collapse navbar-collapse" id="navbarContent">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0 fw-medium align-items-center">
              <li className="nav-item">
                <Link className={`nav-link px-3 ${isActive('/dashboard')}`} to="/dashboard">
                  <i className="bi bi-grid-1x2 me-1"></i> होम / Dashboard
                </Link>
              </li>

              {/* MASTER DROPDOWN */}
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle px-3" href="#!" role="button" data-bs-toggle="dropdown">
                  <i className="bi bi-box-seam me-1"></i> मास्टर / Master
                </a>
                <ul className="dropdown-menu shadow-lg border-0 rounded-4 mt-2">
                  <li>
                    <Link className="dropdown-item py-2" to="/masters/products">
                      <i className="bi bi-tag me-2 text-primary"></i> सामान / Product Master
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item py-2" to="/masters/customers">
                      <i className="bi bi-people me-2 text-success"></i> व्यापारी / Customer Master
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item py-2" to="/masters/vendors">
                      <i className="bi bi-truck me-2 text-warning"></i> विक्रेता / Supplier Master
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item py-2" to="/masters/employees">
                      <i className="bi bi-person-badge me-2 text-info"></i> खलाशी / Employee Master
                    </Link>
                  </li>
                </ul>
              </li>

              {/* ENTRY DROPDOWN */}
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle px-3" href="#!" role="button" data-bs-toggle="dropdown">
                  <i className="bi bi-pencil-square me-1"></i> एन्ट्री / Entry
                </a>
                <ul className="dropdown-menu shadow-lg border-0 rounded-4 mt-2">
                  <li>
                    <Link className="dropdown-item py-2 text-primary fw-bold" to="/entry/boat-expenses">
                      <i className="bi bi-water me-2"></i> पलट / Boat Entry
                    </Link>
                  </li>
                  <li><hr className="dropdown-divider" /></li>
                  <li>
                    <Link className="dropdown-item py-2" to="/entry/sales">
                      <i className="bi bi-receipt me-2 text-success"></i> व्यापारी बील / Sale Entry
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item py-2" to="/entry/purchases">
                      <i className="bi bi-cart-check me-2 text-danger"></i> खरेदी केलेला सामान / Purchase Entry
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item py-2" to="/entry/boxes">
                      <i className="bi bi-box-fill me-2 text-warning"></i> पेटी एन्ट्री / Box Entry Tracker
                    </Link>
                  </li>
                </ul>
              </li>

              {/* PAYMENT DROPDOWN */}
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle px-3" href="#!" role="button" data-bs-toggle="dropdown">
                  <i className="bi bi-cash-stack me-1"></i> पेमेंट / Payment
                </a>
                <ul className="dropdown-menu shadow-lg border-0 rounded-4 mt-2">
                  <li>
                    <Link className="dropdown-item py-2" to="/payments/customer-receipts">
                      <i className="bi bi-wallet2 me-2 text-success"></i> व्यापारी आलेले / Payment Receipt
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item py-2" to="/payments/vendor-vouchers">
                      <i className="bi bi-card-checklist me-2 text-danger"></i> विक्रेता दिलेले / Payment Voucher
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item py-2" to="/payments/employee-salary">
                      <i className="bi bi-currency-rupee me-2 text-primary"></i> खलाशी दिलेले / Employee Payment
                    </Link>
                  </li>
                  <li><hr className="dropdown-divider" /></li>
                  <li>
                    <Link className="dropdown-item py-2 fw-bold text-success" to="/payments/daily-collection">
                      <i className="bi bi-calendar-check me-2"></i> दैनिक जमा / View Daily Collection
                    </Link>
                  </li>
                </ul>
              </li>

              {/* REPORTS DROPDOWN */}
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle px-3" href="#!" role="button" data-bs-toggle="dropdown">
                  <i className="bi bi-graph-up-arrow me-1"></i> रिपोर्ट / Report
                </a>
                <ul className="dropdown-menu shadow-lg border-0 rounded-4 mt-2">
                  <li>
                    <Link className="dropdown-item py-2 fw-bold text-primary" to="/reports/customer-ledger">
                      <i className="bi bi-person-bounding-box me-2"></i> व्यापारी खाते उतारा / Customer Wise Report
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item py-2 fw-bold text-danger" to="/reports/vendor-ledger">
                      <i className="bi bi-truck me-2"></i> विक्रेता खाते उतारा / Vendor Wise Report
                    </Link>
                  </li>
                  <li><hr className="dropdown-divider" /></li>
                  <li>
                    <Link className="dropdown-item py-2" to="/reports/sales">
                      <i className="bi bi-file-earmark-bar-graph me-2 text-success"></i> विक्री बील रिपोर्ट / Sales Report
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item py-2" to="/reports/purchases">
                      <i className="bi bi-file-earmark-spreadsheet me-2 text-danger"></i> खरेदी बील रिपोर्ट / Purchase Report
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item py-2" to="/reports/employees">
                      <i className="bi bi-person-lines-fill me-2 text-info"></i> खलाशी रिपोर्ट / Employee Report
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item py-2" to="/reports/accounts">
                      <i className="bi bi-journal-text me-2 text-primary"></i> पलट व खाते रिपोर्ट / Boat Trip Report
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item py-2" to="/reports/stock">
                      <i className="bi bi-boxes me-2 text-warning"></i> स्टॉक तपशील / Stock Details Report
                    </Link>
                  </li>
                </ul>
              </li>

              {/* SETTINGS */}
              <li className="nav-item">
                <Link className={`nav-link px-3 ${isActive('/settings')}`} to="/settings">
                  <i className="bi bi-gear me-1"></i> सेटिंग्ज / Settings
                </Link>
              </li>
            </ul>

            {/* USER AVATAR & PROFILE DROPDOWN */}
            <div className="d-flex align-items-center gap-2 mt-2 mt-lg-0 justify-content-end">
              <div className="dropdown">
                <button
                  className="btn btn-outline-light btn-sm rounded-pill px-3 py-1 dropdown-toggle d-flex align-items-center gap-2 border-opacity-25"
                  type="button"
                  data-bs-toggle="dropdown"
                >
                  <div className="bg-info text-dark fw-bold rounded-circle d-flex align-items-center justify-content-center" style={{ width: 26, height: 26, fontSize: '0.8rem' }}>
                    {user?.username?.charAt(0).toUpperCase() || 'U'}
                  </div>
                  <span className="fw-semibold small">{user?.username || 'User'}</span>
                </button>
                <ul className="dropdown-menu dropdown-menu-end shadow-lg border-0 rounded-4 mt-2">
                  <li className="dropdown-header py-2">
                    <span className="d-block fw-bold text-dark">{user?.username || 'User'}</span>
                    <span className="small text-muted">{selectedFirm?.firmName || 'All Firms (Admin)'}</span>
                  </li>
                  <li><hr className="dropdown-divider my-1" /></li>
                  <li>
                    <Link className="dropdown-item text-danger py-2" to="#" onClick={handleLogout}>
                      <i className="bi bi-box-arrow-right me-2"></i> लॉग् आऊट / Sign Out
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
